'use strict';

module.exports = require('./components/DocList/QueryEditor').default;


//////////////////
// WEBPACK FOOTER
// ./~/coact/QueryEditor.js
// module id = 1875
// module chunks = 0